import { type MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { sendEmail as SendEmail, sendEmailVariables as SendEmailVariables } from 'types/graphql';
import { SEND_EMAIL_MUTATION } from '../api/sendEmail.api';

/** `sendEmail(input)` command (R-EM1). */
export function useSendEmail(options?: MutationHookOptions<SendEmail, SendEmailVariables>) {
  const [mutate, { loading, error }] = useMutation<SendEmail, SendEmailVariables>(SEND_EMAIL_MUTATION, options);
  const send = useCallback((variables: SendEmailVariables) => mutate({ variables }), [mutate]);
  return { send, loading, error };
}
